<div class="l-title">
  <h2 class="c-title">{{ label }}</h2>
  <img src="./../../../../assets/img/border-title.png" alt="" />
</div>
